import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PortfolioProvider } from './context/PortfolioContext';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Awards from './components/Awards';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollProgressBar from './components/ScrollProgressBar';
import ImpactCounters from './components/ImpactCounters';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import { Toaster } from './components/ui/toaster';
import { useVisitorTracking } from './hooks/useVisitorTracking';
import './App.css';

// Wrapper component to use the tracking hook
const AppContent = () => {
  useVisitorTracking();
  const handleCursorMove = (e) => {
    document.documentElement.style.setProperty('--cursor-x', `${e.clientX}px`);
    document.documentElement.style.setProperty('--cursor-y', `${e.clientY}px`);
  };

  return (
    <div className="App" onMouseMove={handleCursorMove}>
      <div className="cursor-spotlight" aria-hidden />
      <ScrollProgressBar />
      <Routes>
        {/* Public Portfolio */}
        <Route
          path="/"
          element={
            <>
              <Navbar />
              <div className="story-main space-y-24">
                <Hero />
                <ImpactCounters />
                <About />
                <Skills />
                <Experience />
                <Awards />
                <Contact />
                <Footer />
              </div>
            </>
          }
        />

        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <PortfolioProvider>
            <AppContent />
          </PortfolioProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
